<script setup>
  import { computed } from "vue";

  const props = defineProps({
    color: { type: String, default: "primary" }, // primary | red
  });

  const colors = computed(() => {
    switch (props.color) {
      case "red":
        return {
          bgColor: "var(--smoe-red-100)",
          textColor: "var(--smoe-red-500)",
        };
      default: // primary
        return {
          bgColor: "var(--smoe-primary-100)",
          textColor: "var(--smoe-primary-500)",
        };
    }
  });
</script>

<template>
  <n-flex
    align="center"
    justify="space-between"
    class="relative rounded-lg px-4 py-3"
    :style="`
      background-color:${colors.bgColor}
    `"
  >
    <helper-text
      :style="`
      color:${colors.textColor}
    `"
    >
      <slot />
    </helper-text>
    <slot name="right-area"></slot>
  </n-flex>
</template>
